import clsx from 'clsx';
import { OrderStatus } from '../api-new';

export const OrderStatusBadge = (ps: { status: OrderStatus }) => {
  const badge = (
    <span
      className={clsx(
        'text-base font-bold rounded-md px-2 py-1 uppercase border w-fit flex items-center gap-2',
        {
          'bg-green-100 text-green-500 border-green-500':
            ps.status === OrderStatus.READY,
          'bg-green-500 text-white': ps.status === OrderStatus.OPEN,
          'bg-yellow-100 text-yellow-500 border-yellow-500':
            ps.status === OrderStatus.STANDBY,
          'bg-gray-100 text-gray-500 border-gray-500':
            ps.status === OrderStatus.CLOSED ||
            ps.status === OrderStatus.CANCELED,
          'bg-blue-100 text-blue-500 border-blue-500':
            ps.status === OrderStatus.SCHEDULED,
          'bg-red-100 text-red-500 border-red-500':
            ps.status === OrderStatus.ERROR,
        },
      )}>
      {ps.status}
    </span>
  );

  return badge;
};
